import { ActionCreator } from "redux";
import {
  GET_MY_USER_DETAIL_SUCCESS,
  GET_MY_USER_DETAIL_ERROR,
  Member,
  memberActions,
  Companies,
  GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS,
  GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR,
  GET_COMPANIES_SUCCESS,
  Firm,
  GET_FİRM_NAMES_SUCCESS,
  GET_ALL_PERSONNEL_LİST_SUCCESS,
  GET_ALL_PERSONNEL_LİST_ERROR,
  GET_RELATED_MEMBER__NAME_LİST_SUCCESS,
  RelatedMemberNameList,
  AllPersonnel,
  AllMemberListForPosition,
  MainTechnologiesList,
  GET_MAIN_TECHNOLOGIES_LIST_SUCCESS,
  GET_MAIN_TECHNOLOGIES_LIST_ERROR,
  SubTechnologiesList,
  GET_SUB_TECHNOLOGIES_LIST_SUCCESS,
  GET_SUB_TECHNOLOGIES_LIST_ERROR,
  LanguageList,
  GET_LANGUAGE_LİST_SUCCESS,
  GET_LANGUAGE_LİST_ERROR,
  LanguageLevelList,
  GET_LANGUAGE_LEVEL_LİST_SUCCESS,
  GET_LANGUAGE_LEVEL_LİST_ERROR,
  TechnicalSelectTreeList,
  GET_TECHNICICAL_SELECT_TREE_LIST_SUCCESS,
  GET_TECHNICICAL_SELECT_TREE_LIST_ERROR,
  TechnicGroupMainList,
  GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS,
  GET_TECHNİC_GROUP_MAİN_LİST_ERROR,
  TechnicalList,
  GET_ALL_TECHNICAL_GROUP_SUCCESS,
  GET_ALL_TECHNICAL_GROUP_ERROR,
  DomainMainGroupList,
  DomainSubGroupList,
  GET_DOMAİN_MAİN_GROUP_LİST_SUCCESS,
  GET_DOMAİN_MAİN_GROUP_LİST_ERROR,
  GET_DOMAİN_SUB_GROUP_LİST_SUCCESS,
  GET_DOMAİN_SUB_GROUP_LİST_ERROR,
  GET_SEARCHED_PERSONEL_DETAIL_SUCCESS,
  MemberCollageList,
  GET_MEMBER_COLLAGE_LİST_SUCCESS,
  GET_MEMBER_COLLAGE_LİST_ERROR,
  MemberTechnicList,
  GET_MEMBER_TECHNİC_LİST_SUCCESS,
  GET_MEMBER_TECHNİC_LİST_ERROR,
  PersonalCommunicationLevelList,
  GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS,
  GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR,
  GraduationStatusList,
  GET_GRADUATION_STATUS_LIST_SUCCESS,
  GET_GRADUATION_STATUS_LIST_ERROR,
  CountryList,
  GET_COUNTRY_LİST_SUCCESS,
  GET_COUNTRY_LİST_ERROR,
  CityList,
  GET_CITY_LİST_SUCCESS,
  GET_CITY_LİST_ERROR,
  TownList,
  GET_TOWN_LİST_BY_CITY_SUCCESS,
  GET_TOWN_LİST_BY_CITY_ERROR,
  CollageList,
  GET_COLLAGE_LİST_SUCCESS,
  GET_COLLAGE_LİST_ERROR,
  DepartmentList,
  GET_DEPARTMENT_LİST_SUCCESS,
  GET_DEPARTMENT_LİST_ERROR,
  MilitaryServiceStatusList,
  GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS,
  GET_MILITARY_SERVICE_STATUS_LIST_ERROR,
  DriversLicenseList,
  GET_DRIVERS_LICENSE_LIST_SUCCESS,
  GET_DRIVERS_LICENSE_LIST_ERROR,
  TechnicList,
  GET_TECHNIC_LIST_SUCCESS,
  GET_TECHNIC_LIST_ERROR,
  PersonalAbilityList,
  GET_PERSONAL_ABİLİTY_LİST_SUCCESS,
  GET_PERSONAL_ABİLİTY_LİST_ERROR,
  CommunicationParameterList,
  GET_COMMUNICATION_PARAMETER_LIST_SUCCESS,
  GET_COMMUNICATION_PARAMETER_LIST_ERROR,
  PositionList,
  GET_POSITION_LIST_SUCCESS,
  GET_POSITION_LIST_ERROR,
  PositionListTechnicGroup,
  GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS,
  GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR,
  PositionListByCompany,
  GET_POSITION_LIST_BY_COMPANY_SUCCESS,
  GET_POSITION_LIST_BY_COMPANY_ERROR,
  PositionListByProject,
  GET_POSITION_LIST_BY_PROJECT_SUCCESS,
  GET_POSITION_LIST_BY_PROJECT_ERROR,
  GET_ALL_VERSIONS_SUCCESS,
  GET_ALL_VERSIONS_ERROR,
  CREATE_VERSION_SUCCESS,
  CREATE_VERSION_ERROR,
  UPDATE_VERSION_SUCCESS,
  UPDATE_VERSION_ERROR,
  DELETE_VERSION_SUCCESS,
  DELETE_VERSION_ERROR,
} from "../../redux/actions/actionTypes";
import axios, { AxiosError } from "axios";
import apiClient from "../../services/apiClient";
import { SERVICEURL } from "../../appconfig";

const getCompaniesListSuccess: ActionCreator<memberActions> = (
  list: Companies[],
) => {
  return { type: GET_COMPANIES_SUCCESS, payload: list };
};

let getMyUserDetailListSuccess: ActionCreator<memberActions> = (
  list: Member[],
) => {
  return { type: GET_MY_USER_DETAIL_SUCCESS, payload: list };
};
const getMyUserDetailListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_MY_USER_DETAIL_ERROR, payload: message };
};
const getFirmNamesSuccess: ActionCreator<memberActions> = (list: Firm[]) => {
  return { type: GET_FİRM_NAMES_SUCCESS, payload: list };
};
const getRelatedMemberNameListSuccess: ActionCreator<memberActions> = (
  list: RelatedMemberNameList[],
) => {
  return { type: GET_RELATED_MEMBER__NAME_LİST_SUCCESS, payload: list };
};
const getAllPersonnelListSuccess: ActionCreator<memberActions> = (
  list: AllPersonnel[],
) => {
  return { type: GET_ALL_PERSONNEL_LİST_SUCCESS, payload: list };
};

const getAllPersonnelListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_ALL_PERSONNEL_LİST_ERROR, payload: message };
};

const getLanguageListSuccess: ActionCreator<memberActions> = (
  list: LanguageList[],
) => {
  return { type: GET_LANGUAGE_LİST_SUCCESS, payload: list };
};
const getLanguageListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_LANGUAGE_LİST_ERROR, payload: message };
};

const getAllMemberListForPositionSuccess: ActionCreator<memberActions> = (
  list: AllMemberListForPosition[],
) => {
  return { type: GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS, payload: list };
};

const getAllMemberListForPositionError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR, payload: message };
};

const getLanguageLevelListSuccess: ActionCreator<memberActions> = (
  list: LanguageLevelList[],
) => {
  return { type: GET_LANGUAGE_LEVEL_LİST_SUCCESS, payload: list };
};
const getLanguageLevelListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_LANGUAGE_LEVEL_LİST_ERROR, payload: message };
};
const getCountryListSuccess: ActionCreator<memberActions> = (
  list: CountryList[],
) => {
  return { type: GET_COUNTRY_LİST_SUCCESS, payload: list };
};
const getCountryListError: ActionCreator<memberActions> = (message: string) => {
  return { type: GET_COUNTRY_LİST_ERROR, payload: message };
};
const getCityListSuccess: ActionCreator<memberActions> = (list: CityList[]) => {
  return { type: GET_CITY_LİST_SUCCESS, payload: list };
};
const getCityListError: ActionCreator<memberActions> = (message: string) => {
  return { type: GET_CITY_LİST_ERROR, payload: message };
};
const getTownListByCitySuccess: ActionCreator<memberActions> = (
  list: TownList[],
) => {
  return { type: GET_TOWN_LİST_BY_CITY_SUCCESS, payload: list };
};
const getTownListByCityError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_TOWN_LİST_BY_CITY_ERROR, payload: message };
};
const getCollageListSuccess: ActionCreator<memberActions> = (
  list: CollageList[],
) => {
  return { type: GET_COLLAGE_LİST_SUCCESS, payload: list };
};
const getCollageListError: ActionCreator<memberActions> = (message: string) => {
  return { type: GET_COLLAGE_LİST_ERROR, payload: message };
};
const getDepartmentListSuccess: ActionCreator<memberActions> = (
  list: DepartmentList[],
) => {
  return { type: GET_DEPARTMENT_LİST_SUCCESS, payload: list };
};
const getDepartmentListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_DEPARTMENT_LİST_ERROR, payload: message };
};
const getMainTechnologiesListSuccess: ActionCreator<memberActions> = (
  list: MainTechnologiesList[],
) => {
  return { type: GET_MAIN_TECHNOLOGIES_LIST_SUCCESS, payload: list };
};

const getMainTechnologiesListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_MAIN_TECHNOLOGIES_LIST_ERROR, payload: message };
};
const getSubTechnologiesListSuccess: ActionCreator<memberActions> = (
  list: SubTechnologiesList[],
) => {
  return { type: GET_SUB_TECHNOLOGIES_LIST_SUCCESS, payload: list };
};
const getTechnicalSelectTreeListSuccess: ActionCreator<memberActions> = (
  list: TechnicalSelectTreeList[],
) => {
  return { type: GET_TECHNICICAL_SELECT_TREE_LIST_SUCCESS, payload: list };
};

const getTechnicGroupMainListSuccess: ActionCreator<memberActions> = (
  list: TechnicGroupMainList[],
) => {
  return { type: GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS, payload: list };
};

const getTechnicGroupMainListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_TECHNİC_GROUP_MAİN_LİST_ERROR, payload: message };
};

const getTechnicalSelectTreeListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_TECHNICICAL_SELECT_TREE_LIST_ERROR, payload: message };
};

const getSubTechnologiesListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_SUB_TECHNOLOGIES_LIST_ERROR, payload: message };
};

const getMemberTechnicListSuccess: ActionCreator<memberActions> = (
  list: MemberTechnicList[],
) => {
  return { type: GET_MEMBER_TECHNİC_LİST_SUCCESS, payload: list };
};

const getMemberTechnicListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_MEMBER_TECHNİC_LİST_ERROR, payload: message };
};

const getAllTechnicalGroupSuccess: ActionCreator<memberActions> = (
  list: TechnicalList[],
) => {
  return { type: GET_ALL_TECHNICAL_GROUP_SUCCESS, payload: list };
};

const getAllTechnicalGroupError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_ALL_TECHNICAL_GROUP_ERROR, payload: message };
};

const getDomainMainGroupListSuccess: ActionCreator<memberActions> = (
  list: DomainMainGroupList[],
) => {
  return { type: GET_DOMAİN_MAİN_GROUP_LİST_SUCCESS, payload: list };
};

const getDomainMainGroupListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_DOMAİN_MAİN_GROUP_LİST_ERROR, payload: message };
};

const getDomainSubGroupListSuccess: ActionCreator<memberActions> = (
  list: DomainSubGroupList[],
) => {
  return { type: GET_DOMAİN_SUB_GROUP_LİST_SUCCESS, payload: list };
};

const getDomainSubGroupListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_DOMAİN_SUB_GROUP_LİST_ERROR, payload: message };
};

const getSearchedPersonelDetailListSuccess: ActionCreator<memberActions> = (
  list: Member[],
) => {
  return { type: GET_SEARCHED_PERSONEL_DETAIL_SUCCESS, payload: list };
};

const getMemberCollageListSuccess: ActionCreator<memberActions> = (
  list: MemberCollageList[],
) => {
  return { type: GET_MEMBER_COLLAGE_LİST_SUCCESS, payload: list };
};

const getMemberCollageListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_MEMBER_COLLAGE_LİST_ERROR, payload: message };
};

const getPersonalCommunicationLevelListSuccess: ActionCreator<memberActions> = (
  list: PersonalCommunicationLevelList[],
) => {
  return { type: GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS, payload: list };
};

const getPersonalCommunicationLevelListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return {
    type: GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR,
    payload: message,
  };
};

const getGraduationStatusListSuccess: ActionCreator<memberActions> = (
  list: GraduationStatusList[],
) => {
  return { type: GET_GRADUATION_STATUS_LIST_SUCCESS, payload: list };
};

const getGraduationStatusListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_GRADUATION_STATUS_LIST_ERROR, payload: message };
};

const getMilitaryServiceStatusListSuccess: ActionCreator<memberActions> = (
  list: MilitaryServiceStatusList[],
) => {
  return { type: GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS, payload: list };
};

const getMilitaryServiceStatusListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_MILITARY_SERVICE_STATUS_LIST_ERROR, payload: message };
};

const getDriversLicenseListSuccess: ActionCreator<memberActions> = (
  list: DriversLicenseList[],
) => {
  return { type: GET_DRIVERS_LICENSE_LIST_SUCCESS, payload: list };
};

const getDriversLicenseListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_DRIVERS_LICENSE_LIST_ERROR, payload: message };
};

const getTechnicListSuccess: ActionCreator<memberActions> = (
  list: TechnicList[],
) => {
  return { type: GET_TECHNIC_LIST_SUCCESS, payload: list };
};

const getTechnicListError: ActionCreator<memberActions> = (message: string) => {
  return { type: GET_TECHNIC_LIST_ERROR, payload: message };
};

const getPersonalAbilitiyListSuccess: ActionCreator<memberActions> = (
  list: PersonalAbilityList[],
) => {
  return { type: GET_PERSONAL_ABİLİTY_LİST_SUCCESS, payload: list };
};

const getPersonalAbilitiyListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_PERSONAL_ABİLİTY_LİST_ERROR, payload: message };
};

const getCommunicationParameterListSuccess: ActionCreator<memberActions> = (
  list: CommunicationParameterList[],
) => {
  return { type: GET_COMMUNICATION_PARAMETER_LIST_SUCCESS, payload: list };
};

const getCommunicationParameterListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_COMMUNICATION_PARAMETER_LIST_ERROR, payload: message };
};

const getPositionListSuccess: ActionCreator<memberActions> = (
  list: PositionList[],
) => {
  return { type: GET_POSITION_LIST_SUCCESS, payload: list };
};

const getPositionListError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_POSITION_LIST_ERROR, payload: message };
};

const getPositionListTechnicGroupSuccess: ActionCreator<memberActions> = (
  list: PositionListTechnicGroup[],
) => {
  return { type: GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS, payload: list };
};

const getPositionListTechnicGroupError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR, payload: message };
};
const getPositionListByCompanySuccess: ActionCreator<memberActions> = (
  list: PositionListByCompany[],
) => {
  return { type: GET_POSITION_LIST_BY_COMPANY_SUCCESS, payload: list };
};

const getPositionListByCompanyError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_POSITION_LIST_BY_COMPANY_ERROR, payload: message };
};

const getPositionListByProjectSuccess: ActionCreator<memberActions> = (
  list: PositionListByProject[],
) => {
  return { type: GET_POSITION_LIST_BY_PROJECT_SUCCESS, payload: list };
};

const getPositionListByProjectError: ActionCreator<memberActions> = (
  message: string,
) => {
  return { type: GET_POSITION_LIST_BY_PROJECT_ERROR, payload: message };
};

const mytoken = localStorage.getItem("token");
const HEADER = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + mytoken,
  },
};

export function getDomainMainGroupList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetDomainMainList?", HEADER)
      .then((response) => {
        dispatch(getDomainMainGroupListSuccess(response));
      })
      .catch((error) => {
        dispatch(getDomainMainGroupListError("Save error."));
      });
  };
}

export function getDomainSubGroupList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetDomainSubList?", HEADER)
      .then((response) => {
        dispatch(getDomainSubGroupListSuccess(response));
      })
      .catch((error) => {
        dispatch(getDomainSubGroupListError("Save error."));
      });
  };
}

export function getAllTechnicalGroupList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetTechnicalGroup?", HEADER)
      .then((response) => {
        dispatch(getAllTechnicalGroupSuccess(response));
      })
      .catch((error) => {
        console.log(error);

        dispatch(getAllTechnicalGroupError("Save error."));
      });
  };
}

export function getTechnicalSelectTreeList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetTechnicalSelectTreeList?", HEADER)
      .then((response) => {
        dispatch(getTechnicalSelectTreeListSuccess(response));
      })
      .catch((error) => {
        dispatch(getTechnicalSelectTreeListError("Save error."));
      });
  };
}

export function getLanguageLevelList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetLevelList?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getLanguageLevelListSuccess(response.data.data));
        } else {
          dispatch(
            getLanguageLevelListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getLanguageLevelListError(errorMessage));
      });
  };
}

export function getCountryList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetCountryList?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getCountryListSuccess(response.data.data));
        } else {
          dispatch(
            getCountryListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getCountryListError(errorMessage));
      });
  };
}

export function getCityList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetCityList?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getCityListSuccess(response.data.data));
        } else {
          dispatch(
            getCityListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getCityListError(errorMessage));
      });
  };
}

export function getTownListByCity(cityId: string) {
  return (dispatch: (arg0: memberActions) => void) => {
    if (!cityId || cityId === "0") {
      dispatch(getTownListByCitySuccess([]));
      return;
    }

    axios
      .get(SERVICEURL + `api/Data/GetTownListByCity?cityId=${cityId}`, HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getTownListByCitySuccess(response.data.data));
        } else {
          dispatch(
            getTownListByCityError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getTownListByCityError(errorMessage));
      });
  };
}

export function getCollageList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/CandidateParameters/GetUniversities", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getCollageListSuccess(response.data.data));
        } else {
          dispatch(
            getCollageListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getCollageListError(errorMessage));
      });
  };
}

export function getDepartmentList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/CandidateParameters/GetDepartments", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getDepartmentListSuccess(response.data.data));
        } else {
          dispatch(
            getDepartmentListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getDepartmentListError(errorMessage));
      });
  };
}
export function getMemberCollageList(state: { state: { memberId: any } }) {
  const id = state.state.memberId;
  return (dispatch: (arg0: memberActions) => void) => {
    if (id != null) {
      const input = { MemberID: id };
      axios
        .post(SERVICEURL + "api/Personnel/GetEducationList?", input, HEADER)
        .then((response) => {
          dispatch(getMemberCollageListSuccess(response));
        })
        .catch((error) => {
          dispatch(getMemberCollageListError("Save error."));
        });
    }
  };
}

export function getSearchedPersonelDetailList(state: {
  state: { memberId: number };
}) {
  const id = state.state.memberId;
  return (dispatch: (arg0: memberActions) => void) => {
    if (id != null) {
      const input = { MemberId: id };
      axios
        .post(SERVICEURL + "api/Membership/GetMyDetail?", input, HEADER)
        .then((response) => {
          dispatch(getSearchedPersonelDetailListSuccess(response));
        })
        .catch((reason: AxiosError) => {
          dispatch(getMyUserDetailListError("Save error."));
          console.log("Handle else:", reason.message);
        });
    }
  };
}

export function getTechnicGroupMainList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetTechnicalMainGroupList", HEADER)
      .then((response) => {
        dispatch(getTechnicGroupMainListSuccess(response));
      })
      .catch((error) => {
        dispatch(getTechnicGroupMainListError("Save error."));
      });
  };
}

export function getCompaniesList(state: { state: { name: string } }) {
  const name = state.state.name;

  return (dispatch: (arg0: memberActions) => void) => {
    const mytoken = localStorage.getItem("token");
    const HEADER = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + mytoken,
      },
    };
    if (name != null) {
      const input = { memberId: name };

      axios
        .get(SERVICEURL + "api/Data/GetCompanies?", HEADER)
        .then((response) => {
          dispatch(getCompaniesListSuccess(response));
        })
        .catch((reason: AxiosError) => {
          console.log("Handle else: ", reason.message);
        });
    }
  };
}

export function getPositionListByProject(state: { projectId: string | number }) {
  const projectId = state.projectId;

  return (dispatch: (arg0: memberActions) => void) => {
    if (projectId != null && projectId !== "" && projectId !== 0) {
      const input = { ProjectId: projectId };
      axios
        .post(
          SERVICEURL + "api/Position/PositionListingByProject",
          input,
          HEADER,
        )
        .then((response) => {
          dispatch(getPositionListByProjectSuccess(response));
        })
        .catch((error) => {
          dispatch(getPositionListByProjectError("Save error."));
        });
    }
  };
}

export function getPositionListByCompany(state: {
  companyName: string;
  customerName: string;
  ids: number;
  stateCity: {
    Anadolu: boolean;
    Avrupa: boolean;
    Izmir: boolean;
    Ankara: boolean;
    Diger: boolean;
  };
  techvalue: number[];
  state: { teamId: number };
}) {
  const companyName = state.companyName;
  const customerName = state.customerName;
  const techGroup = state.techvalue;
  //const cityID = state.cityID;
  //const technicGroupId = state.techvalue;
  const teamId = state.state.teamId;
  const stateCity = state.stateCity;
  const ids = state.ids;

  var CityIds: number[] = [];
  let cityIds = [...CityIds];
  if (stateCity.Anadolu == true) {
    CityIds.push(34);
  }
  if (stateCity.Anadolu == false) {
    var index = CityIds.indexOf(34);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Avrupa == true) {
    CityIds.push(88);
  }
  if (stateCity.Avrupa == false) {
    var index = CityIds.indexOf(88);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Ankara == true) {
    CityIds.push(6);
  }
  if (stateCity.Ankara == false) {
    var index = CityIds.indexOf(6);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Izmir == true) {
    CityIds.push(35);
  }
  if (stateCity.Izmir == false) {
    var index = CityIds.indexOf(35);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }

  if (stateCity.Diger == true) {
    if (ids != 0) {
      CityIds.push(ids);
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }
  if (stateCity.Diger == false) {
    if (ids != 0) {
      var index = CityIds.indexOf(ids);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }
  return (dispatch: (arg0: memberActions) => void) => {
    if (companyName != null || companyName != "") {
      const input = {
        CompanyName: companyName,
        CustomerName: customerName,
        CityID: CityIds,
        techGroupId: techGroup,
        TeamId: teamId,
      };
      axios
        .post(
          SERVICEURL + "api/Position/PositionListingByCompany",
          input,
          HEADER,
        )
        .then((response) => {
          dispatch(getPositionListByCompanySuccess(response));
        })
        .catch((error) => {
          dispatch(getPositionListByCompanyError("Save error."));
          localStorage.removeItem("token");
          window.location.reload();
        });
    }
  };
}

export function getPositionListByTechnicGroup(state: {
  techvalue: number[];
  ids: number;
  stateCity: {
    Anadolu: boolean;
    Avrupa: boolean;
    Izmir: boolean;
    Ankara: boolean;
    Diger: boolean;
  };
  state: {
    teamId: number;
    workingModelId: number;
    projectTypeId: number;
    companyId: number;
    customerId: number;
  };
  stateWorkingModel: { Remote: boolean; Hybrid: boolean; Onsite: boolean };
  stateProjectType: { Insource: boolean; Outsource: boolean };
}) {
  const teamId = state.state.teamId;
  const techGroup = state.techvalue;
  const workingModelId = state.state.workingModelId;
  const projectTypeId = state.state.projectTypeId;
  const remote = state.stateWorkingModel.Remote;
  const hybrid = state.stateWorkingModel.Hybrid;
  const onsite = state.stateWorkingModel.Onsite;
  const insource = state.stateProjectType.Insource;
  const outsource = state.stateProjectType.Outsource;
  const companyId = state.state.companyId;
  const customerId = state.state.customerId;
  const stateCity = state.stateCity;
  const ids = state.ids;

  var CityIds: number[] = [];
  let cityIds = [...CityIds];
  if (stateCity.Anadolu == true) {
    CityIds.push(34);
  }
  if (stateCity.Anadolu == false) {
    var index = CityIds.indexOf(34);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Avrupa == true) {
    CityIds.push(88);
  }
  if (stateCity.Avrupa == false) {
    var index = CityIds.indexOf(88);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Ankara == true) {
    CityIds.push(6);
  }
  if (stateCity.Ankara == false) {
    var index = CityIds.indexOf(6);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Izmir == true) {
    CityIds.push(35);
  }
  if (stateCity.Izmir == false) {
    var index = CityIds.indexOf(35);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }

  if (stateCity.Diger == true) {
    if (ids != 0) {
      CityIds.push(ids);
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }
  if (stateCity.Diger == false) {
    if (ids != 0) {
      var index = CityIds.indexOf(ids);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }

  //const technicGroupId = state.state.technicGroupId;

  return (dispatch: (arg0: memberActions) => void) => {
    if (teamId != null || projectTypeId != null || workingModelId != null) {
      const input = {
        WorkingModel: workingModelId,
        techGroupId: techGroup,
        CompanyId: companyId,
        CityID: CityIds,
        CustomerId: customerId,
        TeamId: teamId,
        ProjectType: projectTypeId,
        IsRemote: remote,
        IsHybrit: hybrid,
        IsOnsite: onsite,
        IsInsource: insource,
        IsOutsource: outsource,
      };
      axios
        .post(SERVICEURL + "api/Position/PositionListTechnic", input, HEADER)
        .then((response) => {
          dispatch(getPositionListTechnicGroupSuccess(response));
        })
        .catch((error) => {
          dispatch(getPositionListTechnicGroupError("Save error."));
        });
    }
  };
}

export function getPostionList(state: {
  technicGroupFilterId: number;
  techvalue: number[];
  ids: number;
  stateCity: {
    Anadolu: boolean;
    Avrupa: boolean;
    Izmir: boolean;
    Ankara: boolean;
    Diger: boolean;
  };
  state: {
    teamId: number;
    workingModelId: number;
    projectTypeId: number;
    companyId: number;
    customerId: number;
  };
  stateWorkingModel: { Remote: boolean; Hybrid: boolean; Onsite: boolean };
  stateProjectType: { Insource: boolean; Outsource: boolean };
}) {
  //const technicGroupId = state.state.technicGroupId;
  const teamId = state.state.teamId;
  const workingModelId = state.state.workingModelId;
  const projectTypeId = state.state.projectTypeId;
  const techGroup = state.techvalue;
  const remote = state.stateWorkingModel.Remote;
  const hybrid = state.stateWorkingModel.Hybrid;
  const onsite = state.stateWorkingModel.Onsite;
  const insource = state.stateProjectType.Insource;
  const outsource = state.stateProjectType.Outsource;
  const companyId = state.state.companyId;
  const customerId = state.state.customerId;
  const technicGroupFilterId = state.technicGroupFilterId;
  const stateCity = state.stateCity;
  const ids = state.ids;

  var CityIds: number[] = [];
  let cityIds = [...CityIds];
  if (stateCity.Anadolu == true) {
    CityIds.push(34);
  }
  if (stateCity.Anadolu == false) {
    var index = CityIds.indexOf(34);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Avrupa == true) {
    CityIds.push(88);
  }
  if (stateCity.Avrupa == false) {
    var index = CityIds.indexOf(88);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Ankara == true) {
    CityIds.push(6);
  }
  if (stateCity.Ankara == false) {
    var index = CityIds.indexOf(6);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }
  if (stateCity.Izmir == true) {
    CityIds.push(35);
  }
  if (stateCity.Izmir == false) {
    var index = CityIds.indexOf(35);
    if (index !== -1) {
      CityIds.splice(index, 1);
    }
  }

  if (stateCity.Diger == true) {
    if (ids != 0) {
      CityIds.push(ids);
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }
  if (stateCity.Diger == false) {
    if (ids != 0) {
      var index = CityIds.indexOf(ids);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    } else {
      var index = CityIds.indexOf(0);
      if (index !== -1) {
        CityIds.splice(index, 1);
      }
    }
  }

  return (dispatch: (arg0: memberActions) => void) => {
    if (
      techGroup != null ||
      teamId != null ||
      projectTypeId != null ||
      workingModelId != null
    ) {
      const input = {
        TechnicGroupFilterId: technicGroupFilterId,
        techGroupId: techGroup,
        CityID: CityIds,
        WorkingModel: workingModelId,
        CompanyId: companyId,
        CustomerId: customerId,
        TeamId: teamId,
        ProjectType: projectTypeId,
        IsRemote: remote,
        IsHybrit: hybrid,
        IsOnsite: onsite,
        IsInsource: insource,
        IsOutsource: outsource,
      };
      axios
        .post(SERVICEURL + "api/Position/PositionList", input, HEADER)
        .then((response) => {
          dispatch(getPositionListSuccess(response));
        })
        .catch((error) => {
          dispatch(getPositionListError("Save error."));
          localStorage.removeItem("token");
          window.location.reload();
        });
    }
  };
}

export function getPersonelAllList(state: {
  technicId: number;
  value: number[];
  techvalue: number[];
  state: {
    name: string;
    phoneNo: string;
    email: string;
    englishLevelId: number;
    experienceYearEnd: number;
    experienceYearStart: number;
    salaryEndValue: number;
    salaryFirstValue: number;
    features: number[];
    domainId: number;
  };
}) {
  const name = state.state.name;
  const phoneNo = state.state.phoneNo.replaceAll("_", "").trimRight();
  const email = state.state.email;
  const techGroup = state.techvalue;
  const englishLevelId = state.state.englishLevelId;
  const experienceYearEnd = state.state.experienceYearEnd;
  const experienceYearStart = state.state.experienceYearStart;
  const salaryEndValue = state.state.salaryEndValue;
  const salaryFirstValue = state.state.salaryFirstValue;
  const technicId = state.technicId;
  const features = state.value;
  const domainId = state.state.domainId;

  return (dispatch: (arg0: memberActions) => void) => {
    if (
      name != null ||
      phoneNo != null ||
      email != null ||
      techGroup != null ||
      englishLevelId != null ||
      experienceYearEnd != null ||
      experienceYearStart != null ||
      features != null ||
      domainId != null
    ) {
      const input = {
        name: name,
        phoneNo: phoneNo,
        email: email,
        techGroupId: techGroup,
        languageId: englishLevelId,
        endingTotalExperienceYear: experienceYearEnd,
        startingTotalExperienceYear: experienceYearStart,
        endingSalaryExpectation: salaryEndValue,
        startingSalaryExpectation: salaryFirstValue,
        technicalSkillId: technicId,
        features: features,
        domainId: domainId,
      };
      axios
        .post(SERVICEURL + "api/Membership/GetAllMemberList", input, HEADER)
        .then((response) => {
          dispatch(getAllPersonnelListSuccess(response));
        })
        .catch((error) => {
          dispatch(getAllPersonnelListError("Save error."));
        });
    }
  };
}

export function getMemberTechnicList(state: { state: { memberId: any } }) {
  const id = state.state.memberId;
  return (dispatch: (arg0: memberActions) => void) => {
    if (id != null) {
      const input = { memberId: id };
      axios
        .post(SERVICEURL + "api/Personnel/GetTechnicList?", input, HEADER)
        .then((response) => {
          dispatch(getMemberTechnicListSuccess(response));
        })
        .catch((error) => {
          dispatch(getMemberTechnicListError("Save error."));
        });
    }
  };
}

export function getMyUserDetailList(state: { state: { memberId: string } }) {
  const id = state.state.memberId;
  return (dispatch: (arg0: memberActions) => void) => {
    const mytoken = localStorage.getItem("token");
    const HEADER = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + mytoken,
      },
    };

    const params: Record<string, string> = {};
    if (id) {
      params.memberId = id;
    }

    axios
      .get(SERVICEURL + "api/Membership/GetMyDetail", {
        params: params,
        headers: HEADER.headers,
      })
      .then((response) => {
        const backendResponse = (response as any)?.data;
        const userDetailData = backendResponse?.data;

        if (!userDetailData) {
          console.error("Kullanıcı detay bilgisi alınamadı.");
          return;
        }
        try {
          const role =
            userDetailData?.Role ??
            userDetailData?.role ??
            (userDetailData?.RoleId != null ? userDetailData.RoleId : null);

          if (role != null && role !== "") {
            // localStorage.setItem("roles", String(role));
          }
        } catch {
          // no-op
        }
        dispatch(getMyUserDetailListSuccess(userDetailData));
      })
      .catch((reason: AxiosError) => {
        console.log("Handle else: ", reason.message);
      });
  };
}
export function getSubTechnologiesList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetSubTechnologiesList?", HEADER)
      .then((response) => {
        dispatch(getSubTechnologiesListSuccess(response));
      })
      .catch((error) => {
        dispatch(getSubTechnologiesListError("Save error."));
      });
  };
}

export function getLanguageList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/CandidateParameters/GetLanguages", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getLanguageListSuccess(response.data.data));
        } else {
          dispatch(
            getLanguageListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getLanguageListError(errorMessage));
      });
  };
}

export function getAllMemberListForPosition(state: {
  technicId: number;
  value: number[];
  techvalue: number[];
  domainValue: number[];
  state: {
    englishLevelId: number;
    experienceYearEnd: number;
    experienceYearStart: number;
    salaryEndValue: number;
    salaryFirstValue: number;
    features: number[];
    languageId: number;
    languageLevelId: number;
    dateStart: Date | null;
    dateEnd: Date | null;
  };
}) {
  const techGroup = state.techvalue;
  const englishLevelId = state.state.englishLevelId;
  const experienceYearEnd = state.state.experienceYearEnd;
  const experienceYearStart = state.state.experienceYearStart;
  const salaryEndValue = state.state.salaryEndValue;
  const salaryFirstValue = state.state.salaryFirstValue;
  const technicId = state.technicId;
  const features = state.value;
  const domainId = state.domainValue;
  const languageId = state.state.languageId;
  const languageLevelId = state.state.languageLevelId;
  const dateStart = state.state.dateStart;
  const dateEnd = state.state.dateEnd;

  const Language = {
    languageParameterId: languageId,
    levelId: languageLevelId,
  };

  return (dispatch: (arg0: memberActions) => void) => {
    if (
      techGroup != null ||
      englishLevelId != null ||
      experienceYearEnd != null ||
      experienceYearStart != null ||
      features != null ||
      languageId != null ||
      languageLevelId != null ||
      domainId != null ||
      dateStart != null ||
      dateEnd != null
    ) {
      const input = {
        techGroupId: techGroup,
        languageId: englishLevelId,
        endingTotalExperienceYear: experienceYearEnd,
        startingTotalExperienceYear: experienceYearStart,
        endingSalaryExpectation: salaryEndValue,
        startingSalaryExpectation: salaryFirstValue,
        technicalSkillId: technicId,
        features: features,
        otherlanguageId: Language,
        domainId: domainId,
        StartDate: dateStart,
        EndDate: dateEnd,
      };
      axios
        .post(
          SERVICEURL + "api/Membership/GetAllMemberListForPosition",
          input,
          HEADER,
        )
        .then((response) => {
          dispatch(getAllMemberListForPositionSuccess(response));
        })
        .catch((error) => {
          dispatch(getAllMemberListForPositionError("Save error."));
        });
    }
  };
}

export function getMainTechnologiesList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetMainTechnologiesList?", HEADER)
      .then((response) => {
        dispatch(getMainTechnologiesListSuccess(response));
      })
      .catch((error) => {
        dispatch(getMainTechnologiesListError("Save error."));
      });
  };
}

export function getFirmNamesList(state: { state: { firmName: string } }) {
  const name = state.state.firmName;

  return (dispatch: (arg0: memberActions) => void) => {
    const mytoken = localStorage.getItem("token");
    const HEADER = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + mytoken,
      },
    };
    if (name != null) {
      const input = { name: name };

      axios
        .get(SERVICEURL + "api/Data/GetFirmNames", HEADER)
        .then((response) => {
          dispatch(getFirmNamesSuccess(response));
        })
        .catch((reason: AxiosError) => {
          console.log("Handle else: ", reason.message);
        });
    }
  };
}

export function getRelatedMemberNameList() {
  return (dispatch: (arg0: memberActions) => void) => {
    const mytoken = localStorage.getItem("token");
    const HEADER = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + mytoken,
      },
    };

    axios
      .get(SERVICEURL + "api/Data/GetIKPersonnel", HEADER)
      .then((response) => {
        dispatch(getRelatedMemberNameListSuccess(response));
      })
      .catch((reason: AxiosError) => {
        console.log("Handle else: ", reason.message);
      });
  };
}

export function getPersonalCommunicationLevelList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetPersonalCommunicationLevelList?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(
            getPersonalCommunicationLevelListSuccess(response.data.data),
          );
        } else {
          dispatch(
            getPersonalCommunicationLevelListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getPersonalCommunicationLevelListError(errorMessage));
      });
  };
}

export function getGraduationStatusList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetGraduationStatus?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getGraduationStatusListSuccess(response.data.data));
        } else {
          dispatch(
            getGraduationStatusListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getGraduationStatusListError(errorMessage));
      });
  };
}

export function getMilitaryServiceStatusList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetMilitaryServiceStatus?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getMilitaryServiceStatusListSuccess(response.data.data));
        } else {
          dispatch(
            getMilitaryServiceStatusListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getMilitaryServiceStatusListError(errorMessage));
      });
  };
}

export function getDriversLicenseList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetDrivingLicense?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getDriversLicenseListSuccess(response.data.data));
        } else {
          dispatch(
            getDriversLicenseListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getDriversLicenseListError(errorMessage));
      });
  };
}

export function getTechnicList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetTechnicList", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getTechnicListSuccess(response.data.data));
        } else {
          dispatch(
            getTechnicListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getTechnicListError(errorMessage));
      });
  };
}

export function getPersonalAbilityList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetPersonalAbilityList?", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getPersonalAbilitiyListSuccess(response.data.data));
        } else {
          dispatch(
            getPersonalAbilitiyListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getPersonalAbilitiyListError(errorMessage));
      });
  };
}

export function getCommunicationParameterList() {
  return (dispatch: (arg0: memberActions) => void) => {
    axios
      .get(SERVICEURL + "api/Data/GetCommunicationParameterList", HEADER)
      .then((response) => {
        if (response.data.code === 200 && response.data.data) {
          dispatch(getCommunicationParameterListSuccess(response.data.data));
        } else {
          dispatch(
            getCommunicationParameterListError(
              response.data.message || "Veri yüklenirken hata oluştu.",
            ),
          );
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Veri yüklenirken hata oluştu.";
        dispatch(getCommunicationParameterListError(errorMessage));
      });
  };
}

// Version Actions
const getAllVersionsSuccess = (data: any): memberActions => ({
  type: GET_ALL_VERSIONS_SUCCESS,
  payload: data,
});

const getAllVersionsError = (message: string): memberActions => ({
  type: GET_ALL_VERSIONS_ERROR,
  payload: message,
});

const createVersionSuccess = (data: any): memberActions => ({
  type: CREATE_VERSION_SUCCESS,
  payload: data,
});

const createVersionError = (message: string): memberActions => ({
  type: CREATE_VERSION_ERROR,
  payload: message,
});

const updateVersionSuccess = (data: any): memberActions => ({
  type: UPDATE_VERSION_SUCCESS,
  payload: data,
});

const updateVersionError = (message: string): memberActions => ({
  type: UPDATE_VERSION_ERROR,
  payload: message,
});

const deleteVersionSuccess = (data: any): memberActions => ({
  type: DELETE_VERSION_SUCCESS,
  payload: data,
});

const deleteVersionError = (message: string): memberActions => ({
  type: DELETE_VERSION_ERROR,
  payload: message,
});

export const getAllVersions = () => async (dispatch: any) => {
  try {
    const response = await apiClient.get("api/Nav/GetAllVersions");
    const apiData = response.data?.data || [];

    if (response.data?.code === 200 && Array.isArray(apiData)) {
      const mappedVersions = apiData.map((item: any) => ({
        id: item.id?.toString(),
        version: item.version,
        title: item.title,
        description: item.description,
        features: item.features || [],
        isCurrent: item.iscurrent ?? item.isCurrent ?? false,
      }));

      dispatch(getAllVersionsSuccess(mappedVersions));
    } else {
      dispatch(
        getAllVersionsError(response.data?.message || "Versiyonlar alınamadı."),
      );
    }
  } catch (error) {
    const err = error as AxiosError<any>;
    const errorMessage =
      err.response?.data?.message || err.message || "Versiyonlar alınamadı.";
    dispatch(getAllVersionsError(errorMessage));
  }
};

export const createVersion =
  (versionData: {
    Version: string;
    Title: string;
    Description: string;
    Features: string[];
    IsCurrent: boolean;
  }) =>
  async (dispatch: any) => {
    try {
      const response = await apiClient.post(
        "api/Nav/CreateVersion",
        versionData,
      );
      if (response.data?.code === 200) {
        dispatch(createVersionSuccess(response.data));
        dispatch(getAllVersions());
      } else {
        dispatch(
          createVersionError(
            response.data?.message || "Versiyon oluşturulamadı.",
          ),
        );
      }
    } catch (error) {
      const err = error as AxiosError<any>;
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Versiyon oluşturulamadı.";
      dispatch(createVersionError(errorMessage));
    }
  };

export const updateVersion =
  (versionData: {
    VersionId: number;
    Version: string;
    Title: string;
    Description: string;
    Features: string[];
    IsCurrent: boolean;
  }) =>
  async (dispatch: any) => {
    try {
      const response = await apiClient.post(
        "api/Nav/UpdateVersion",
        versionData,
      );
      if (response.data?.code === 200) {
        dispatch(updateVersionSuccess(response.data));
        dispatch(getAllVersions());
      } else {
        dispatch(
          updateVersionError(
            response.data?.message || "Versiyon güncellenemedi.",
          ),
        );
      }
    } catch (error) {
      const err = error as AxiosError<any>;
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Versiyon güncellenemedi.";
      dispatch(updateVersionError(errorMessage));
    }
  };

export const deleteVersion = (versionId: number) => async (dispatch: any) => {
  try {
    const response = await apiClient.post("api/Nav/DeleteVersion", {
      VersionId: versionId,
      ProjectName: "Wiser",
    });
    if (response.data?.code === 200) {
      dispatch(deleteVersionSuccess(response.data));
      dispatch(getAllVersions());
    } else {
      dispatch(
        deleteVersionError(response.data?.message || "Versiyon silinemedi."),
      );
    }
  } catch (error) {
    const err = error as AxiosError<any>;
    const errorMessage =
      err.response?.data?.message || err.message || "Versiyon silinemedi.";
    dispatch(deleteVersionError(errorMessage));
  }
};
